query DaDataSuggestAddress(
  $query: String!
  $count: Int = 10
  $locations: [DaDataLocationInput]
) {
  dadataSuggestAddress(query: $query, count: $count, locations: $locations) {
    suggestions {
      value
      unrestricted_value
      data {
        postal_code
        country
        region
        city
        street
        house
        flat
        fias_id
        geo_lat
        geo_lon
      }
    }
  }
}
